import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, Quote } from "lucide-react";
import api from "@/lib/api";
import { PageShell } from "@/components/PageShell";

const PORTRAIT = "https://static.prod-images.emergentagent.com/jobs/5306c248-bca6-4547-8c45-6083734dd662/images/f49df9ddd69e6fe27e7503ccb40e6f37ccf5b9fb6ec8076f1488689719f962d8.png";

export default function Memorial() {
  const [event, setEvent] = useState(null);
  useEffect(() => { api.get("/event").then((r) => setEvent(r.data)); }, []);

  return (
    <PageShell>
      <div className="bg-slate-950 text-white noise min-h-[70vh]">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 py-20 lg:py-28 text-center">
          <img src={PORTRAIT} alt="Darren Power" className="mx-auto h-44 w-44 rounded-full object-cover ring-4 ring-sky-400/40 shadow-2xl" />
          <p className="mt-8 text-sky-400 text-sm uppercase tracking-[0.35em] font-semibold">In Loving Memory</p>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl">Darren "Pow" Power</h1>
          <div className="mt-10 relative">
            <Quote className="mx-auto text-sky-500/40 mb-4" size={40} />
            <p className="font-display italic text-2xl lg:text-3xl leading-relaxed text-slate-200">
              "{event?.tribute || "A true friend is never truly gone. His spirit lives on in the memories of those who love him."}"
            </p>
          </div>
        </div>
      </div>

      <section className="max-w-3xl mx-auto px-5 lg:px-8 py-20 space-y-8 text-lg leading-relaxed text-slate-700">
        <p>
          Each year we gather at Elmgreen Golf Club to celebrate the life of our great friend, Darren.
          What began as a way to honour his memory has grown into a treasured tradition — a day of
          laughter, competition, and community, exactly as he would have wanted it.
        </p>
        <p>
          Darren loved the game, but more than that he loved the people around him. This day brings
          together the friends, family and fellow golfers whose lives he touched. Every swing, every
          putt, and every story shared on the fairways keeps his spirit alive.
        </p>
        <blockquote className="border-l-4 border-green-500 pl-6 py-2 font-display italic text-2xl text-slate-900">
          "Please join us once again for a golf day outing in memory of our great friend, Pow."
        </blockquote>
        <p>
          Whether you knew Darren personally or are joining us for the first time, you are warmly
          welcome. Together we raise a glass, tee it up, and remember a truly good man.
        </p>

        <div className="pt-6 flex flex-wrap gap-3">
          <Link to="/register" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-green-600 text-white font-semibold hover:-translate-y-0.5 transition-all">
            Enter in his memory
          </Link>
          <Link to="/donate" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-sky-50 text-sky-700 font-semibold hover:-translate-y-0.5 transition-all">
            <Heart size={16} /> Make a donation
          </Link>
        </div>
      </section>
    </PageShell>
  );
}
